import { render, staticRenderFns } from "./ParentCategoryEdit.vue?vue&type=template&id=4cf7cec2&scoped=true"
import script from "./ParentCategoryEdit.vue?vue&type=script&lang=js"
export * from "./ParentCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf7cec2",
  null
  
)

export default component.exports